/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
import '../tinymce/da';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "Få adgang til det pæne HTML-redigeringsværktøj"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "Tilgængelighedskontrol"
  },
  "action_to_take_b626a99a": {
    "message": "Handling, der skal tages:"
  },
  "add_8523c19b": {
    "message": "Tilføj"
  },
  "add_a_caption_2a915239": {
    "message": "Tilføj billedtekst"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "Tilføj alternativ tekst til billedet"
  },
  "add_another_f4e50d57": {
    "message": "Tilføj en mere"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "Tilføj undertekster"
  },
  "add_image_60b2de07": {
    "message": "Tilføj billede"
  },
  "add_one_9e34a6f8": {
    "message": "Tilføj en!"
  },
  "additional_considerations_f3801683": {
    "message": "Yderligere overvejelser"
  },
  "address_applied_64269b0b": {
    "message": "Adresse anvendt"
  },
  "address_removed_fcb496e0": {
    "message": "Adresse fjernet"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "Tilstødende links med samme URL skal være et enkelt link."
  },
  "aleph_f4ffd155": {
    "message": "Aleph"
  },
  "align_11050992": {
    "message": "Juster"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "Justering og lister"
  },
  "all_4321c3a1": {
    "message": "Alle"
  },
  "all_apps_a50dea49": {
    "message": "Alle apps"
  },
  "allow_media_download_16dcf2bd": {
    "message": "Tillad download af medier"
  },
  "allow_transcript_download_3fa239f0": {
    "message": "Tillad download af transskription"
  },
  "alpha_15d59033": {
    "message": "Alfa"
  },
  "alphabetical_55b5b4e0": {
    "message": "Alfabetisk"
  },
  "alt_attribute_text_should_not_contain_more_than_12_e21d4040": {
    "message": "Alternativ attributtekst må ikke indeholde mere end 120 tegn."
  },
  "alt_text_611fb322": {
    "message": "Alt-tekst"
  },
  "amalg_coproduct_c589fb12": {
    "message": "Amalg (Koprodukt)"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "Der opstod en fejl, da filen skulle læses"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "Der opstod en fejl under oprettelse af en netværksanmodning"
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "Der opstod en fejl ved overførsel af mediet."
  },
  "and_7fcc2911": {
    "message": "Og"
  },
  "angle_c5b4ec50": {
    "message": "Vinkel"
  },
  "announcement_fb4cb645": {
    "message": "Besked"
  },
  "announcement_list_da155734": {
    "message": "Beskedliste"
  },
  "announcements_a4b8ed4a": {
    "message": "Beskeder"
  },
  "apply_781a2546": {
    "message": "Tildel"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "Anvend ændringer på alle instanser af denne Icon Maker i faget"
  },
  "approaches_the_limit_893aeec9": {
    "message": "Nærmer sig grænsen"
  },
  "approximately_e7965800": {
    "message": "Cirka"
  },
  "apps_54d24a47": {
    "message": "Apps"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "Er du sikker på, du vil annullere? Ændringer, du har foretaget, kan ikke blive gemt."
  },
  "arrows_464a3e54": {
    "message": "Pile"
  },
  "art_icon_8e1daad": {
    "message": "Kunst-ikon"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "Dimensionsforhold bevares"
  },
  "assignment_976578a8": {
    "message": "Opgave"
  },
  "assignments_1e02582c": {
    "message": "Opgaver"
  },
  "asterisk_82255584": {
    "message": "Stjerne"
  },
  "attributes_963ba262": {
    "message": "Attributter"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "Lyd- og videooptagelse understøttes ikke, brug en anden browser."
  },
  "audio_options_feb58e2c": {
    "message": "Lydindstillinger"
  },
  "audio_options_tray_33a90711": {
    "message": "Skuffe til lydindstillinger"
  },
  "audio_player_for_title_20cc70d": {
    "message": "Audioafspiller til { title }"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "Der findes automatisk gemt indhold. Vil du indlæse det automatisk gemte indhold i stedet?"
  },
  "available_folders_694d0436": {
    "message": "Tilgængelige mapper"
  },
  "background_1bc88842": {
    "message": "Baggrund"
  },
  "backslash_b2d5442d": {
    "message": "Omvendt skråstreg"
  },
  "bar_ec63ed6": {
    "message": "Bar"
  },
  "basic_554cdc0a": {
    "message": "Grundlæggende"
  },
  "because_501841b": {
    "message": "Fordi"
  },
  "below_81d4dceb": {
    "message": "Under"
  },
  "beta_cb5f307e": {
    "message": "Beta"
  },
  "big_circle_16b2e604": {
    "message": "Stor cirkel"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "Binomial koefficient"
  },
  "black_4cb01371": {
    "message": "Sort"
  },
  "blue_daf8fea9": {
    "message": "Blå"
  },
  "bold_applied_42d547b7": {
    "message": "Fed skrift anvendt"
  },
  "bold_removed_da474a5c": {
    "message": "Fed skrift fjernet"
  },
  "border_5b08b06d": {
    "message": "Kant"
  },
  "bottom_15a2a9be": {
    "message": "Bund"
  },
  "bottom_third_5f5fec1d": {
    "message": "Nederste tredjedel"
  },
  "bowtie_5f9629e4": {
    "message": "Butterfly"
  },
  "brick_f2656265": {
    "message": "Mursten"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "Annullér"
  },
  "cap_product_3a5265a6": {
    "message": "Cap product"
  },
  "caption_manager_aae0906f": {
    "message": "Håndtering af undertekster"
  },
  "center_align_e68d9997": {
    "message": "Centerjustering"
  },
  "centered_dot_64d5e378": {
    "message": "Centreret prik"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "Centrerede vandrette prikker"
  },
  "change_alt_text_92654906": {
    "message": "Skift alternativ tekst"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "Skift overskrift-tag til afsnit"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "Skift kun denne overskrifts niveau"
  },
  "change_text_color_1aecb912": {
    "message": "Skift tekstfarve"
  },
  "changes_will_apply_after_you_save_this_page_fb324e9d": {
    "message": "Ændringerne træder i kraft, når du har gemt denne side."
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "Ændringer, du har foretaget, kan ikke blive gemt."
  },
  "characters_9d897d1c": {
    "message": "Tegn"
  },
  "characters_no_spaces_485e5367": {
    "message": "Tegn (ingen mellemrum)"
  },
  "check_accessibility_3c78211c": {
    "message": "Kontroller tilgængelighed"
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "Kontrollerer tilgængelighedsproblemer"
  },
  "chi_54a32644": {
    "message": "Chi"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "Vælg billedtekstfil"
  },
  "choose_usage_rights_33683854": {
    "message": "Vælg brugsrettigheder ..."
  },
  "circle_484abe63": {
    "message": "Cirkel"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "cirkel usorteret liste"
  },
  "clear_2084585f": {
    "message": "Ryd"
  },
  "clear_image_3213fe62": {
    "message": "Ryd billede"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "Klik eller shift-klik for html-editoren."
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "Klik for at integrere { imageName }"
  },
  "click_to_hide_preview_3c707763": {
    "message": "Klik for at skjule forhåndsvisning"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "Klik for at indsætte et link i editoren."
  },
  "click_to_show_preview_faa27051": {
    "message": "Klik for at vise forhåndsvisning"
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "Luk en menu eller dialog. Sender dig også tilbage til redigeringsområdet"
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "Luk tilgængelighedskontrol"
  },
  "close_d634289d": {
    "message": "Luk"
  },
  "close_keyboard_shortcuts_modal_291ce074": {
    "message": "Luk tastaturgenvej-modalen"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "Filen med undertekster skal være mindre end { maxKb } kb"
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "Billedtekster / undertekster"
  },
  "clubs_suit_c1ffedff": {
    "message": "Klør (kulør)"
  },
  "collab_575ac7bc": {
    "message": "Samarbejde"
  },
  "collaborations_5c56c15f": {
    "message": "Samarbejde"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "Skjul { types }"
  },
  "color_a363e1b0": {
    "message": "Farve"
  },
  "color_contrast_4c418add": {
    "message": "Farvekontrast"
  },
  "color_contrast_ratio_687782f0": {
    "message": "Farvekontrastforhold"
  },
  "color_picker_6b359edf": {
    "message": "Farvevælger"
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "Farvevælger ({ colorName } valgt)"
  },
  "color_popup_af39810f": {
    "message": "Farve-popup"
  },
  "column_e1ae5c64": {
    "message": "Kolonne"
  },
  "column_group_1c062368": {
    "message": "Kolonnegruppe"
  },
  "complex_numbers_a543d004": {
    "message": "Komplekse tal"
  },
  "computer_1d7dfa6f": {
    "message": "Computer"
  },
  "congruent_5a244acd": {
    "message": "Kongruent"
  },
  "contains_311f37b7": {
    "message": "Indeholder"
  },
  "content_1440204b": {
    "message": "Indhold"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "Indholdet i editoren vil blive ændret. Tryk på Annuller for at beholde det originale indhold."
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "Indhold er stadig ved at blive uploadet. Hvis du fortsætter, bliver det ikke integreret korrekt."
  },
  "content_subtype_5ce35e88": {
    "message": "Indholdsundertype"
  },
  "content_type_2cf90d95": {
    "message": "Indholdstype"
  },
  "continue_to_youtube_content_a34f0f85": {
    "message": "Fortsæt til YouTube-indhold"
  },
  "coproduct_e7838082": {
    "message": "Koprodukt"
  },
  "copyright_holder_66ee111": {
    "message": "Rettighedshaver:"
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "Kunne ikke indsætte indhold: \"{ itemType }\" elementer er i øjeblikket ikke understøttet i Canvas."
  },
  "count_40eced3b": {
    "message": "Antal"
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0 ord}\n    one {1 ord}\n  other {# ord}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {# element indlæst}\n  other {# elementer indlæst}\n}"
  },
  "course_documents_104d76e0": {
    "message": "Fagdokumenter"
  },
  "course_files_62deb8f8": {
    "message": "Fagets filer"
  },
  "course_files_a31f97fc": {
    "message": "Fagets filer"
  },
  "course_images_f8511d04": {
    "message": "Fagbilleder"
  },
  "course_link_b369426": {
    "message": "Faglink"
  },
  "course_links_b56959b9": {
    "message": "Faglinks"
  },
  "course_media_ec759ad": {
    "message": "Fagmedier"
  },
  "course_navigation_dd035109": {
    "message": "Fagnavigation"
  },
  "create_icon_110d6463": {
    "message": "Opret ikon"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "Opret Icon Maker-ikon"
  },
  "creative_commons_license_725584ae": {
    "message": "Creative Commons licens:"
  },
  "crop_image_41bf940c": {
    "message": "Beskær billede"
  },
  "crop_image_807ebb08": {
    "message": "Beskær billede"
  },
  "cup_product_14174434": {
    "message": "Cup product"
  },
  "current_image_f16c249c": {
    "message": "Nuværende billede"
  },
  "current_link_945a47ee": {
    "message": "Nuværende link"
  },
  "current_volume_level_c55ab825": {
    "message": "Nuværende lydstyrke"
  },
  "custom_6979cd81": {
    "message": "Brugerdefineret"
  },
  "cyan_c1d5f68a": {
    "message": "Cyan"
  },
  "dagger_57e0f4e5": {
    "message": "Kors"
  },
  "date_added_ed5ad465": {
    "message": "Dato tilføjet"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "Dekorativt ikon"
  },
  "decorative_image_fde98579": {
    "message": "Dekorativt billede"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "Dekorativ { TYPE_UPPER }"
  },
  "decrease_indent_d9cf469d": {
    "message": "Formindsk indrykning"
  },
  "decrease_rich_content_area_82068f64": {
    "message": "Reducer Rich Content-området"
  },
  "deep_purple_bb3e2907": {
    "message": "Dyb lilla"
  },
  "default_9db103d": {
    "message": "Standard"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "standard punktliste usorteret liste"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "standard numerisk sorteret liste"
  },
  "definite_integral_fe7ffed1": {
    "message": "Bestemt integral"
  },
  "degree_symbol_4a823d5f": {
    "message": "Grad-symbol"
  },
  "delimiters_4db4840d": {
    "message": "Begrænsere"
  },
  "delta_53765780": {
    "message": "Delta"
  },
  "describe_the_icon_f6a18823": {
    "message": "(Beskriv ikonet)"
  },
  "describe_the_type_ff448da5": {
    "message": "(Beskriv { TYPE })"
  },
  "description_436c48d7": {
    "message": "Beskrivelse"
  },
  "details_98a31b68": {
    "message": "Nærmere oplysninger"
  },
  "diagonal_dots_7d71b57e": {
    "message": "Diagonale prikker"
  },
  "diamond_b8dfe7ae": {
    "message": "Diamant"
  },
  "diamonds_suit_526abaaf": {
    "message": "Rude (kulør)"
  },
  "digamma_258ade94": {
    "message": "Digamma"
  },
  "dimension_type_f5fa9170": {
    "message": "Dimensionstype"
  },
  "directionality_26ae9e08": {
    "message": "Retningsbestemthed"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "Rediger LaTeX direkte"
  },
  "disable_preview_222bdf72": {
    "message": "Deaktiver forhåndsvisning"
  },
  "discussion_6719c51d": {
    "message": "Diskussion"
  },
  "discussions_a5f96392": {
    "message": "Diskussioner"
  },
  "discussions_index_6c36ced": {
    "message": "Diskussionsoversigt"
  },
  "disjoint_union_e74351a8": {
    "message": "Usammenhængende forening"
  },
  "display_options_315aba85": {
    "message": "Visningsindstillinger"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "Vis tekstlink (åbnes i en ny fane)"
  },
  "div_applied_49ad83fc": {
    "message": "Div anvendt"
  },
  "div_removed_d13f8e17": {
    "message": "Div fjernet"
  },
  "division_sign_72190870": {
    "message": "Divisionstegn"
  },
  "document_678cd7bf": {
    "message": "Dokument"
  },
  "documents_81393201": {
    "message": "Dokumenter"
  },
  "done_54e3d4b6": {
    "message": "Udført"
  },
  "double_dagger_faf78681": {
    "message": "Dobbelt kors"
  },
  "down_5831a426": {
    "message": "Ned"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "Ned og venstre diagonal pil"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "Ned og højre diagonal pil"
  },
  "download_filename_2baae924": {
    "message": "Download { filename }"
  },
  "downward_arrow_cca52012": {
    "message": "Pil ned"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "Nedadpegende trekant"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "Træk en fil her hen"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "Træk og slip eller klik for at browse din computer"
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "Træk i håndtaget. Brug op- og ned-pilene til at ændre størrelse"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "Forfalder: Flere datoer"
  },
  "due_when_7eed10c6": {
    "message": "Forfalder: { when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "Rediger alternativ tekst for denne ikoninstans"
  },
  "edit_c5fbea07": {
    "message": "Redigér"
  },
  "edit_course_link_5a5c3c59": {
    "message": "Rediger faglink"
  },
  "edit_equation_f5279959": {
    "message": "Rediger ligning"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "Rediger eksisterende Icon Maker-ikon"
  },
  "edit_icon_2c6b0e91": {
    "message": "Redigeringsikon"
  },
  "edit_link_7f53bebb": {
    "message": "Rediger link"
  },
  "editor_status_bar_653f44ee": {
    "message": "Redaktørstatuslinje"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "Element begynder med { start }"
  },
  "embed_828fac4a": {
    "message": "Indlejre"
  },
  "embed_code_314f1bd5": {
    "message": "Indlejr kode"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "Indlejr indhold fra eksternt værktøj"
  },
  "embed_image_1080badc": {
    "message": "Integrer billede"
  },
  "embed_video_a97a64af": {
    "message": "Indlejr video"
  },
  "embedded_content_aaeb4d3d": {
    "message": "indlejret indhold"
  },
  "empty_set_91a92df4": {
    "message": "Tomt sæt"
  },
  "encircled_dot_8f5e51c": {
    "message": "Prik i cirkel"
  },
  "encircled_minus_72745096": {
    "message": "Minus i cirkel"
  },
  "encircled_plus_36d8d104": {
    "message": "Plus i cirkel"
  },
  "encircled_times_5700096d": {
    "message": "Tider i cirkel"
  },
  "engineering_icon_f8f3cf43": {
    "message": "Teknik-ikon"
  },
  "english_icon_25bfe845": {
    "message": "Engelsk-ikon"
  },
  "enter_a_media_title_81b490ec": {
    "message": "Indtast en medietitel"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "Indtast mindst 3 tegn for at søge"
  },
  "enter_replacement_text_17631bbc": {
    "message": "indtast erstatningstekst"
  },
  "enter_search_text_26cb4459": {
    "message": "indtast søgetekst"
  },
  "epsilon_54bb8afa": {
    "message": "Epsilon"
  },
  "epsilon_variant_d31f1e77": {
    "message": "Epsilon (variant)"
  },
  "equals_sign_c51bdc58": {
    "message": "Lig med-symbol"
  },
  "equation_1c5ac93c": {
    "message": "Regnestykke"
  },
  "equation_editor_39fbc3f1": {
    "message": "Redigeringsværktøj til regnestykker"
  },
  "equilibrium_6ff3040b": {
    "message": "Ligevægt"
  },
  "equivalence_class_7b0f11c0": {
    "message": "Ækvivalensklasse"
  },
  "equivalent_identity_654b3ce5": {
    "message": "Ækvivalent (identitet)"
  },
  "eta_b8828f99": {
    "message": "Eta"
  },
  "exists_2e62bdaa": {
    "message": "Findes"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "Afslut fuld skærm"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "Udvid forhåndsvisning som standard"
  },
  "expand_to_see_types_f5d29352": {
    "message": "Udvid for at se { types }"
  },
  "external_link_d3f9e62a": {
    "message": "Eksternt link"
  },
  "external_tool_frame_70b32473": {
    "message": "Ramme af eksternt værktøj"
  },
  "external_tools_6e77821": {
    "message": "Eksterne værktøjer"
  },
  "extra_large_b6cdf1ff": {
    "message": "Ekstra stor"
  },
  "extra_large_width_x_height_px_915571fa": {
    "message": "Ekstra stor ({ width } x { height } px)"
  },
  "extra_small_9ae33252": {
    "message": "Ekstra lille"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "Fritids-ikon"
  },
  "f_function_fe422d65": {
    "message": "F (funktion)"
  },
  "fail_544e5dde": {
    "message": "IKKE BESTÅET"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "Kunne ikke hente filindhold"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "Kunne ikke hente indhold fra eksternt værktøj"
  },
  "file_name_8fd421ff": {
    "message": "Filnavn"
  },
  "file_preview_21667a6e": {
    "message": "Filforhåndsvisning"
  },
  "file_preview_for_filename_ab314195": {
    "message": "Filforhåndsvisning for { fileName }"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "Kvote for fillagring er overskredet"
  },
  "file_url_c12b64be": {
    "message": "Fil-URL"
  },
  "filename_file_icon_602eb5de": {
    "message": "{ filename } filikon"
  },
  "filename_image_preview_6cef8f26": {
    "message": "{ filename } billedets forhåndsvisning"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "{ filename } tekstens forhåndsvisning"
  },
  "files_c300e900": {
    "message": "Filer"
  },
  "files_index_af7c662b": {
    "message": "Filoversigt"
  },
  "find_8d605019": {
    "message": "Find"
  },
  "find_and_replace_6e345933": {
    "message": "Find og erstat"
  },
  "finish_bc343002": {
    "message": "Færdig"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "Ret overskriftshierarki"
  },
  "flat_music_76d5a5c3": {
    "message": "Sænket (musik)"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "Værktøjslinje med indstillinger for fokuselement"
  },
  "folder_tree_fbab0726": {
    "message": "Mappetræ"
  },
  "for_all_b919f972": {
    "message": "For alle"
  },
  "format_4247a9c5": {
    "message": "Format"
  },
  "format_as_a_list_142210c3": {
    "message": "Listeformat"
  },
  "formatting_5b143aa8": {
    "message": "Formatering"
  },
  "forward_slash_3f90f35e": {
    "message": "Skråstreg"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "Fundet automatisk gemt indhold"
  },
  "found_count_plural_0_results_one_result_other_resu_46aeaa01": {
    "message": "Fandt { count, plural,\n     =0 {# resultater}\n    one {# resultat}\n  other {# resultater}\n}"
  },
  "fraction_41bac7af": {
    "message": "Brøk"
  },
  "fullscreen_873bf53f": {
    "message": "Fuld skærm"
  },
  "gamma_1767928": {
    "message": "Gamma"
  },
  "generating_preview_45b53be0": {
    "message": "Genererer forhåndsvisning ..."
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "GIF/PNG-format billeder større end { size } KB understøttes ikke i øjeblikket."
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "Gå til redigerings-menulinjen"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "Gå til redigerings-værktøjslinjen"
  },
  "grades_a61eba0a": {
    "message": "Karakterer"
  },
  "graphics_text_bc9568bc": {
    "message": "Grafiktekst"
  },
  "greater_than_e98af662": {
    "message": "Større end"
  },
  "greater_than_or_equal_b911949a": {
    "message": "Større end eller lig med"
  },
  "greek_65c5b3f7": {
    "message": "Græsk"
  },
  "green_15af4778": {
    "message": "Grøn"
  },
  "grey_a55dceff": {
    "message": "Grå"
  },
  "group_documents_8bfd6ae6": {
    "message": "Gruppens dokumenter"
  },
  "group_files_4324f3df": {
    "message": "Gruppefiler"
  },
  "group_files_82e5dcdb": {
    "message": "Gruppefiler"
  },
  "group_images_98e0ac17": {
    "message": "Gruppens billeder"
  },
  "group_isomorphism_45b1458c": {
    "message": "Gruppe isomorfisme"
  },
  "group_link_63e626b3": {
    "message": "Gruppelink"
  },
  "group_links_9493129e": {
    "message": "Gruppelinks"
  },
  "group_media_2f3d128a": {
    "message": "Gruppens medier"
  },
  "group_navigation_99f191a": {
    "message": "Gruppenavigation"
  },
  "h_bar_bb94deae": {
    "message": "H-bar"
  },
  "hat_ea321e35": {
    "message": "Hat"
  },
  "header_column_f27433cb": {
    "message": "Overskriftskolonne"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "Overskriftsrække- og kolonne"
  },
  "header_row_f33eb169": {
    "message": "Overskriftsrække"
  },
  "heading_2_5b84eed2": {
    "message": "Overskrift 2"
  },
  "heading_3_2c83de44": {
    "message": "Overskrift 3"
  },
  "heading_4_b2e74be7": {
    "message": "Overskrift 4"
  },
  "heading_h_applied_eccd294d": {
    "message": "Overskrift { h } anvendt"
  },
  "heading_h_removed_745f24a6": {
    "message": "Overskrift { h } fjernet"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "Overskriftsniveauer bør ikke springes over."
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "Overskrift, der starter med { start }"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "Overskrifter må ikke indeholde mere end 120 tegn."
  },
  "health_icon_8d292eb5": {
    "message": "Sundheds-ikon"
  },
  "hearts_suit_e50e04ca": {
    "message": "Hjerter (kulør)"
  },
  "height_69b03e15": {
    "message": "Højde"
  },
  "hexagon_d8468e0d": {
    "message": "Sekskant"
  },
  "hide_description_bfb5502e": {
    "message": "Skjul beskrivelse"
  },
  "hide_title_description_caf092ef": {
    "message": "Skjul { title } beskrivelse"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "Fremhæv et element for at aktivere værktøjslinjen til elementindstilling"
  },
  "home_351838cd": {
    "message": "Startside"
  },
  "how_to_request_and_edit_captions_a49a9c6b": {
    "message": "Hvordan anmoder og redigerer man undertekster?"
  },
  "html_code_editor_fd967a44": {
    "message": "html kode-editor"
  },
  "html_editor_fb2ab713": {
    "message": "HTML-editor"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "Jeg har opnået tilladelse til at bruge denne fil."
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "Jeg er rettighedshaveren"
  },
  "icon_215a1dc6": {
    "message": "Ikon"
  },
  "icon_8168b2f8": {
    "message": "ikon"
  },
  "icon_color_b86dd6d6": {
    "message": "Ikonfarve"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "Icon Maker-ikoner"
  },
  "icon_options_7e32746e": {
    "message": "Ikonindstillinger"
  },
  "icon_options_tray_2b407977": {
    "message": "Skuffe til ikonindstillinger"
  },
  "icon_preview_1782a1d9": {
    "message": "Ikonforhåndsvisning"
  },
  "icon_shape_30b61e7": {
    "message": "Ikon-form"
  },
  "icon_size_9353edea": {
    "message": "Ikon-størrelse"
  },
  "if_left_empty_link_text_will_display_as_course_lin_2a34eedb": {
    "message": "Hvis linket er tomt, vises tekst som faglinkets navn"
  },
  "if_usage_rights_are_required_the_file_will_not_pub_841e276e": {
    "message": "Hvis brugsrettigheder er påkrævet, vil filen ikke offentliggøres, før det er aktiveret på siden Filer."
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "Hvis du ikke vælger brugsrettigheder nu, vil denne fil ikke blive offentliggjort, når den uploades."
  },
  "image_8ad06": {
    "message": "Billede"
  },
  "image_c1c98202": {
    "message": "billede"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "Billedfilnavne bør ikke bruges som den alternative attribut, der beskriver billedindholdet."
  },
  "image_options_5412d02c": {
    "message": "Billedindstillinger"
  },
  "image_options_tray_90a46006": {
    "message": "Billedindstillinger-bakke"
  },
  "image_to_crop_3a34487d": {
    "message": "Billede til beskæring"
  },
  "image_with_filename_file_aacd7180": {
    "message": "Billede med filnavn { file }"
  },
  "images_7ce26570": {
    "message": "Billeder"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "Billeder skal indeholde en alternativ attribut, der beskriver billedindholdet."
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "Imaginær del (af komplekst tal)"
  },
  "in_element_of_19ca2f33": {
    "message": "I (element af)"
  },
  "increase_indent_6af90f7c": {
    "message": "Øg indrykning"
  },
  "increase_rich_content_area_340b775": {
    "message": "Forøg Rich Content-området"
  },
  "indefinite_integral_6623307e": {
    "message": "Ubestemt integral"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ index } af { max }"
  },
  "indigo_2035fc55": {
    "message": "Indigo"
  },
  "inference_fed5c960": {
    "message": "Udledning"
  },
  "infinity_7a10f206": {
    "message": "Uendelighed"
  },
  "input_field_for_alpha_678265fd": {
    "message": "Indtastningsfelt for alfa"
  },
  "input_field_for_blue_561e020a": {
    "message": "Indtastningsfelt for blå"
  },
  "input_field_for_green_67f8b2b6": {
    "message": "Indtastningsfelt for grøn"
  },
  "input_field_for_red_86a84615": {
    "message": "Indtastningsfelt for rød"
  },
  "insert_593145ef": {
    "message": "Indsæt"
  },
  "insert_link_6dc23cae": {
    "message": "Indsæt link"
  },
  "insert_math_equation_57c6e767": {
    "message": "Indsæt matematikregnestykke"
  },
  "integers_336344e1": {
    "message": "Heltal"
  },
  "intersection_cd4590e4": {
    "message": "Fællesmængde"
  },
  "invalid_description_991e23bb": {
    "message": "Ugyldig beskrivelse"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "Ugyldig indtastning."
  },
  "invalid_file_c11ba11": {
    "message": "Ugyldig fil"
  },
  "invalid_file_type_881cc9b2": {
    "message": "Ugyldig filtype"
  },
  "invalid_url_cbde79f": {
    "message": "Ugyldig URL"
  },
  "iota_11c932a9": {
    "message": "Iota"
  },
  "issue_num_total_f94536cf": {
    "message": "Udstedelse { num }/{ total }"
  },
  "italic_applied_8f59a684": {
    "message": "Kursiv anvendt"
  },
  "italic_removed_17cbab6f": {
    "message": "Kursiv fjernet"
  },
  "kappa_2f14c816": {
    "message": "Kappa"
  },
  "kappa_variant_eb64574b": {
    "message": "Kappa (variant)"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "Genvejstaster"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "Tastaturer navigerer til links ved hjælp af Tab-tasten. To tilstødende links, der fører til samme destination, kan være forvirrende for tastaturbrugere."
  },
  "lambda_4f602498": {
    "message": "Lambda"
  },
  "language_arts_icon_a798b0f8": {
    "message": "Sprogkunst-ikon"
  },
  "languages_icon_9d20539": {
    "message": "Sprog-ikon"
  },
  "large_9c5e80e7": {
    "message": "Stor"
  },
  "large_text_e7ba08cd": {
    "message": "Stor tekst"
  },
  "large_width_x_height_px_c61c2fd": {
    "message": "Stor ({ width } x { height } px)"
  },
  "learn_ad3b3505": {
    "message": "Lær"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "Få mere at vide om tilstødende links"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "Få mere at vide om farvekontrast"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "Få mere at vide om at organisere sideoverskrifter"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "Få mere at vide om korrekt struktur for sideoverskrifter"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "Få mere at vide om tabeloverskrifter"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "Få mere at vide om at bruge alt-tekst til billeder"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "Få mere at vide om brug af billedtekster med tabeller"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "Få mere at vide om at bruge filnavne som alt-tekst"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "Få mere at vide om at bruge lister"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "Få mere at vide om at bruge anvendelsesområde-attributter med tabeller"
  },
  "leave_as_is_4facfe55": {
    "message": "Lad det være, som det er"
  },
  "left_3ea9d375": {
    "message": "Venstre"
  },
  "left_align_43d95491": {
    "message": "Venstrejustering"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "Venstre vinkelparantes"
  },
  "left_arrow_4fde1a64": {
    "message": "Venstre pil"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "Venstre pil med krog"
  },
  "left_ceiling_ee9dd88a": {
    "message": "Venstre loft"
  },
  "left_curly_brace_1726fb4": {
    "message": "Left Curly Brace"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "Venstre nedadgående harpunpil"
  },
  "left_floor_29ac2274": {
    "message": "Venstre etage"
  },
  "left_to_right_e9b4fd06": {
    "message": "Venstre til højre"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "Venstre opadgående harpunpil"
  },
  "leftward_arrow_1e4765de": {
    "message": "Venstre pil"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "Venstre-pegende trekant"
  },
  "less_than_a26c0641": {
    "message": "Mindre end"
  },
  "less_than_or_equal_be5216cb": {
    "message": "Mindre end eller lig med"
  },
  "library_icon_ae1e54cf": {
    "message": "Bibliotek-ikon"
  },
  "light_blue_5374f600": {
    "message": "Lyseblå"
  },
  "link_7262adec": {
    "message": "Link"
  },
  "link_options_a16b758b": {
    "message": "Link-muligheder"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "linktype: { linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "Link med tekst, der begynder med { start }"
  },
  "links_14b70841": {
    "message": "Links"
  },
  "links_to_an_external_site_de74145d": {
    "message": "Links til en ekstern webside."
  },
  "lists_cd1336fc": {
    "message": "Lister"
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "Lister skal have listeformat."
  },
  "load_more_35d33c7": {
    "message": "Indlæs flere"
  },
  "loading_25990131": {
    "message": "Indlæser ..."
  },
  "loading_bde52856": {
    "message": "Indlæser"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "indlæsning af undertekster mislykkedes."
  },
  "loading_external_tool_d839042c": {
    "message": "Indlæser eksternt værktøj"
  },
  "loading_failed_b3524381": {
    "message": "Indlæsning mislykkedes ..."
  },
  "loading_failed_e6a9d8ef": {
    "message": "Indlæsning mislykkedes."
  },
  "loading_folders_d8b5869e": {
    "message": "Indlæser mapper"
  },
  "loading_placeholder_for_filename_792ef5e8": {
    "message": "Indlæser pladsholder for { fileName }"
  },
  "loading_please_wait_d276220a": {
    "message": "Indlæser, vent venligst"
  },
  "loading_preview_9f077aa1": {
    "message": "Indlæser forhåndsvisning"
  },
  "lock_speed_at_1x_57d4f815": {
    "message": "Lås hastighed ved 1x"
  },
  "locked_762f138b": {
    "message": "Låst"
  },
  "logical_equivalence_76fca396": {
    "message": "Logisk ækvivalens"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "Logisk ækvivalens (kort)"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "Logisk ækvivalens (kort og tyk)"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "Logisk ækvivalens (tyk)"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "Lave vandrette prikker"
  },
  "magenta_4a65993c": {
    "message": "Magenta"
  },
  "maps_to_e5ef7382": {
    "message": "Svarer til"
  },
  "math_icon_ad4e9d03": {
    "message": "Matematik-ikon"
  },
  "media_af190855": {
    "message": "Medier"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "Mediefil behandles. Prøv igen senere."
  },
  "media_options_saved_560c4ec8": {
    "message": "Medieindstillinger gemt."
  },
  "media_title_2112243b": {
    "message": "Medietitel"
  },
  "medium_5a8e9ead": {
    "message": "Medium"
  },
  "medium_width_x_height_px_b076f6b6": {
    "message": "Mellem ({ width } x { height } px)"
  },
  "merge_links_2478df96": {
    "message": "Sammenlæg links"
  },
  "mic_a7f3d311": {
    "message": "Mikrofon"
  },
  "microphone_disabled_15c83130": {
    "message": "Mikrofon deaktiveret"
  },
  "middle_27dc1d5": {
    "message": "I midten"
  },
  "minimize_file_preview_da911944": {
    "message": "Minimer fil-forhåndsvisning"
  },
  "minimize_video_20aa554b": {
    "message": "Minimer video"
  },
  "minus_fd961e2e": {
    "message": "Minus"
  },
  "minus_plus_3461f637": {
    "message": "Minus/plus"
  },
  "misc_3b692ea7": {
    "message": "Bland"
  },
  "miscellaneous_e9818229": {
    "message": "Diverse"
  },
  "module_90d9fd32": {
    "message": "Modul"
  },
  "modules_c4325335": {
    "message": "Moduler"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "Flytter billede for at beskære { directionWord }"
  },
  "mu_37223b8b": {
    "message": "My"
  },
  "multi_color_image_63d7372f": {
    "message": "Billede i flere farver"
  },
  "multiplication_sign_15f95c22": {
    "message": "Multiplikationstegn"
  },
  "music_icon_4db5c972": {
    "message": "Musik-ikon"
  },
  "my_files_2f621040": {
    "message": "Mine filer"
  },
  "n_th_root_9991a6e4": {
    "message": "N''te rod"
  },
  "nabla_1e216d25": {
    "message": "Nabla"
  },
  "name_1aed4a1b": {
    "message": "Navn"
  },
  "name_color_ceec76ff": {
    "message": "{ name } ({ color })"
  },
  "natural_music_54a70258": {
    "message": "Naturlig (musik)"
  },
  "natural_numbers_3da07060": {
    "message": "Naturlige tal"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "Naviger gennem menuen eller værktøjslinjen"
  },
  "navigation_ee9af92d": {
    "message": "Navigation"
  },
  "nested_greater_than_d852e60d": {
    "message": "Indlejret større end"
  },
  "nested_less_than_27d17e58": {
    "message": "Indlejret mindre end"
  },
  "new_quiz_34aacba6": {
    "message": "Ny test"
  },
  "next_40e12421": {
    "message": "Næste"
  },
  "next_findtext_9d69f0fe": {
    "message": "Næste { findText }"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "Der blev ikke fundet nogen tilgængelighedsproblemer."
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "Der er ikke oprettet beskeder endnu."
  },
  "no_announcements_found_20185afc": {
    "message": "Ingen beskeder fundet."
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "Der er ikke oprettet opgaver endnu."
  },
  "no_assignments_found_79e46d7f": {
    "message": "Ingen opgaver fundet."
  },
  "no_changes_to_save_d29f6e91": {
    "message": "Ingen ændringer at gemme."
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "Der er ikke oprettet diskussioner endnu."
  },
  "no_discussions_found_9284063b": {
    "message": "Ingen diskussioner fundet."
  },
  "no_e16d9132": {
    "message": "Nej"
  },
  "no_file_chosen_9a880793": {
    "message": "Ingen fil valgt"
  },
  "no_headers_9bc7dc7f": {
    "message": "Ingen overskrifter"
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "Der er ikke oprettet moduler endnu."
  },
  "no_modules_found_2df43a40": {
    "message": "Ingen moduler fundet."
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "Der er ikke oprettet sider endnu."
  },
  "no_pages_found_6799350": {
    "message": "Ingen sider fundet."
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "Der findes ikke forhåndsvisning for denne fil."
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "Der er ikke oprettet test endnu."
  },
  "no_quizzes_found_c80c537a": {
    "message": "Ingen test fundet."
  },
  "no_results_940393cf": {
    "message": "Ingen resultater."
  },
  "no_results_found_58717065": {
    "message": "Ingen resultater fundet"
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "Ingen resultater fundet for { filterTerm }"
  },
  "no_video_1ed00b26": {
    "message": "Ingen video"
  },
  "none_3b5e34d2": {
    "message": "Ingen"
  },
  "none_selected_b93d56d2": {
    "message": "Ingen valgt"
  },
  "normal_text_7b03da48": {
    "message": "Normal tekst"
  },
  "not_equal_6e2980e6": {
    "message": "Ikke lig"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "Ikke i (ikke et element af)"
  },
  "not_negation_1418ebb8": {
    "message": "Ikke (negation)"
  },
  "not_subset_dc2b5e84": {
    "message": "Ikke delmængde"
  },
  "not_subset_strict_23d282bf": {
    "message": "Ikke delmængde (streng)"
  },
  "not_superset_5556b913": {
    "message": "Ikke overmængde"
  },
  "not_superset_strict_24e06f36": {
    "message": "Ikke overmængde (streng)"
  },
  "nu_1c0f6848": {
    "message": "Ny"
  },
  "octagon_e48be9f": {
    "message": "Octagon"
  },
  "olive_6a3e4d6b": {
    "message": "Oliven"
  },
  "omega_8f2c3463": {
    "message": "Omega"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "En af følgende stilarter skal tilføjes for at gemme et ikon: Ikonfarve, konturstørrelse, ikontekst eller billede"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "En eller flere filer kunne ikke indsættes. Prøv at uploade eller trække og slippe filer."
  },
  "open_circle_e9bd069": {
    "message": "Åben cirkel"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "Åbn dialogen for denne genvejstast"
  },
  "open_title_application_fd624fc5": {
    "message": "Åbn { title } applikation"
  },
  "operators_a2ef9a93": {
    "message": "Operatører"
  },
  "options_3ab0ea65": {
    "message": "Muligheder"
  },
  "or_9b70ccaa": {
    "message": "Eller"
  },
  "orange_81386a62": {
    "message": "Orange"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "Sorterede og usorterede lister"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "Andre redigeringsgenveje kan findes på"
  },
  "outline_color_3ef2cea7": {
    "message": "Konturfarve"
  },
  "outline_size_a6059a21": {
    "message": "Konturstørrelse"
  },
  "p_is_not_a_valid_protocol_b1c4efaa": {
    "message": "{ p } er ikke en gyldig protokol."
  },
  "page_50c4823d": {
    "message": "Side"
  },
  "pages_e5414c2c": {
    "message": "Sider"
  },
  "paragraph_5e5ad8eb": {
    "message": "Afsnit"
  },
  "paragraph_applied_959b3fe5": {
    "message": "Afsnit anvendt"
  },
  "paragraph_removed_d09320e": {
    "message": "Afsnit fjernet"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "Paragraf begynder med { start }"
  },
  "parallel_d55d6e38": {
    "message": "Parallel"
  },
  "partial_derivative_4a9159df": {
    "message": "Delvis (afledt)"
  },
  "pass_1c19a2b3": {
    "message": "BESTÅET"
  },
  "paste_5963d1c1": {
    "message": "Sæt ind"
  },
  "pause_12af3bb4": {
    "message": "Pause"
  },
  "pentagon_17d82ea3": {
    "message": "Femkant"
  },
  "people_b4ebb13c": {
    "message": "Deltagere"
  },
  "percentage_34ab7c2c": {
    "message": "Procentdel"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "Procent skal være et tal"
  },
  "percentage_must_be_at_least_percentage_a98ca8fc": {
    "message": "Procent skal være mindst { percentage }%"
  },
  "performing_arts_icon_f3497486": {
    "message": "Scenekunst-ikon"
  },
  "perpendicular_7c48ede4": {
    "message": "Vinkelret"
  },
  "phi_4ac33b6d": {
    "message": "Phi"
  },
  "phi_variant_c9bb3ac5": {
    "message": "Phi (variant)"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "Idræt-ikon"
  },
  "pi_dc4f0bd8": {
    "message": "Pi"
  },
  "pi_variant_10f5f520": {
    "message": "Pi (variant)"
  },
  "pick_a_color_557abfb0": {
    "message": "Vælg en farve"
  },
  "pink_68ad45cb": {
    "message": "Lyserød"
  },
  "pixels_52ece7d1": {
    "message": "Pixels"
  },
  "pixels_must_be_at_least_width_x_height_px_e965edd5": {
    "message": "Pixels skal være mindst { width } x { height }px"
  },
  "play_1a47eaa7": {
    "message": "Afspil"
  },
  "play_media_comment_35257210": {
    "message": "Afspil medie kommentar."
  },
  "play_media_comment_by_name_from_createdat_c230123d": {
    "message": "Afspil mediekommentar af { name } fra { createdAt }."
  },
  "player_layout_14e09a29": {
    "message": "Spillerlayout"
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "Lad Canvas få adgang til din mikrofon og webcam."
  },
  "please_choose_a_file_c2449cc": {
    "message": "Vælg en fil"
  },
  "please_enter_a_file_name_f159edc1": {
    "message": "Venligst indtast et filnavn"
  },
  "please_enter_a_valid_video_url_from_a_supported_pl_30dc0596": {
    "message": "Indtast en gyldig video-URL fra en understøttet platform."
  },
  "please_select_a_file_of_a_supported_type_1fc578f2": {
    "message": "Vælg en fil af en understøttet type"
  },
  "plus_d43cd4ec": {
    "message": "Plus"
  },
  "plus_minus_f8be2e83": {
    "message": "Plus/minus"
  },
  "posted_when_a578f5ab": {
    "message": "Slået op: { when }"
  },
  "power_set_4f26f316": {
    "message": "Potensmængde"
  },
  "precedes_196b9aef": {
    "message": "Kommer før"
  },
  "precedes_equal_20701e84": {
    "message": "Kommer før lig med"
  },
  "preformatted_d0670862": {
    "message": "Præformatteret"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "Forrige"
  },
  "preview_53003fd2": {
    "message": "Eksempel"
  },
  "preview_a3f8f854": {
    "message": "FORHÅNDSVISNING"
  },
  "preview_in_overlay_ed772c46": {
    "message": "Overlejret forhåndsvisning"
  },
  "preview_inline_9787330": {
    "message": "Indbygget forhåndsvisning"
  },
  "previous_bd2ac015": {
    "message": "Forrige"
  },
  "previous_findtext_8dfbfd30": {
    "message": "Forrige { findText }"
  },
  "previously_chosen_colors_f1338315": {
    "message": "Tidligere valgte farver"
  },
  "prime_917ea60e": {
    "message": "Forbered"
  },
  "prime_numbers_13464f61": {
    "message": "Primtal"
  },
  "product_39cf144f": {
    "message": "Produkt"
  },
  "proportional_f02800cc": {
    "message": "Proportional"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": "Protokollen skal være ftp, http, https, mailto, skype, tel eller kan udelades"
  },
  "psi_e3f5f0f7": {
    "message": "Psi"
  },
  "published_c944a23d": {
    "message": "Offentliggjort"
  },
  "published_when_302d8e23": {
    "message": "Offentliggjort: { when }"
  },
  "pumpkin_904428d5": {
    "message": "Græskar"
  },
  "purple_7678a9fc": {
    "message": "Lilla"
  },
  "quaternions_877024e0": {
    "message": "Kvaternioner"
  },
  "quiz_e0dcce8f": {
    "message": "Test"
  },
  "quizzes_7e598f57": {
    "message": "Test"
  },
  "rational_numbers_80ddaa4a": {
    "message": "Rationelle tal"
  },
  "real_numbers_7c99df94": {
    "message": "Reelle tal"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "Reel del (af komplekst tal)"
  },
  "record_7c9448b": {
    "message": "Optag"
  },
  "record_upload_media_5fdce166": {
    "message": "Optag/overfør medier"
  },
  "recording_98da6bda": {
    "message": "Optagelse"
  },
  "red_8258edf3": {
    "message": "Rød"
  },
  "relationships_6602af70": {
    "message": "Forhold"
  },
  "religion_icon_246e0be1": {
    "message": "Religion-ikon"
  },
  "remove_f47dc62a": {
    "message": "Fjern"
  },
  "remove_filename_3ea029f6": {
    "message": "Fjern { filename }"
  },
  "remove_heading_style_5fdc8855": {
    "message": "Fjern overskriftsstil"
  },
  "remove_link_d1f2f4d0": {
    "message": "Fjern link"
  },
  "replace_all_d3d68b3": {
    "message": "Erstat alle"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "Erstat alle { findText } med { replaceText }"
  },
  "replace_e61834a7": {
    "message": "Erstat"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "Erstat { findText } med { replaceText }"
  },
  "replace_with_eeff01ad": {
    "message": "Udskift med"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "Erstattede { alertFindText } med { alertReplaceText }"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "Erstattede alle { alertFindText } med { alertReplaceText }"
  },
  "reset_95a81614": {
    "message": "Nulstil"
  },
  "resize_ec83d538": {
    "message": "Tilpas størrelse"
  },
  "restore_auto_save_deccd84b": {
    "message": "Gendan automatisk gemt indhold?"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "Resultat { index } af { max }."
  },
  "reverse_turnstile_does_not_yield_7558be06": {
    "message": "Omvendt drejekors (giver ikke efter)"
  },
  "rho_a0244a36": {
    "message": "Rho"
  },
  "rho_variant_415245cd": {
    "message": "Rho (variant)"
  },
  "rich_content_editor_2708ef21": {
    "message": "Rich Content Editor"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "RTF-område. Tryk på { OSKey }+F8 for genveje i Rich Content Editor."
  },
  "right_71ffdc4d": {
    "message": "Højre"
  },
  "right_align_39e7a32a": {
    "message": "Højrejustering"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "Højre vinkelparantes"
  },
  "right_arrow_35e0eddf": {
    "message": "Højre pil"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "Højre pil med krog"
  },
  "right_ceiling_839dc744": {
    "message": "Højre loft"
  },
  "right_curly_brace_5159d5cd": {
    "message": "Right Curly Brace"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "Højre nedadgående harpunpil"
  },
  "right_floor_5392d5cf": {
    "message": "Højre etage"
  },
  "right_to_left_9cfb092a": {
    "message": "Højre mod venstre"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "Højre opadgående harpunpil"
  },
  "rightward_arrow_32932107": {
    "message": "Højre pil"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "Højre-pegende trekant"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "Roter billedet -90 grader"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "Roter billedet 90 grader"
  },
  "rotation_9699c538": {
    "message": "Rotation"
  },
  "row_fc0944a7": {
    "message": "Række"
  },
  "row_group_979f5528": {
    "message": "Rækkegruppe"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "Desværre er det pæne HTML-redigeringsværktøj ikke tilgængeligt på tastaturet. Få adgang til det rå HTML-redigeringsværktøj her."
  },
  "save_11a80ec3": {
    "message": "Gem"
  },
  "save_copy_ca63944e": {
    "message": "Gem kopi"
  },
  "save_media_cb9e786e": {
    "message": "Gem medier"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "Gemte Icon Maker-ikoner"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "Skærmlæsere kan ikke bestemme, hvad der vises i et billede uden alternativ tekst, og filnavne er ofte en meningsløs række tal og bogstaver, der ikke beskriver konteksten eller betydningen."
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "Skærmlæsere kan ikke bestemme, hvad der vises i et billede uden alternativ tekst, der beskriver billedets indhold og betydning. Alternativ tekst skal være enkel og kortfattet."
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "Skærmlæsere kan ikke bestemme, hvad der vises i et billede uden alternativ tekst, der beskriver billedets indhold og betydning."
  },
  "screen_readers_cannot_interpret_tables_without_the_bd861652": {
    "message": "Skærmlæsere kan ikke fortolke tabeller uden den rette struktur. Tabeloverskrifter giver en ide om indholdet og dets omfang."
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "Skærmlæsere kan ikke fortolke tabeller uden den rette struktur. Tabelbetegnelser beskriver tabellens kontekst og generelle indhold."
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "Skærmlæsere kan ikke fortolke tabeller uden den rette struktur. Tabeloverskrifter giver en ide om indholdet og en oversigt over det."
  },
  "script_l_42a7b254": {
    "message": "Script L"
  },
  "search_280d00bd": {
    "message": "Søg"
  },
  "select_audio_source_21043cd5": {
    "message": "Vælg lydkilde"
  },
  "select_crop_shape_d441feeb": {
    "message": "Vælg beskæringsform"
  },
  "select_language_7c93a900": {
    "message": "Vælg sprog"
  },
  "select_video_source_1b5c9dbe": {
    "message": "Vælg videokilde"
  },
  "selected_274ce24f": {
    "message": "Valgt"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "Valgt { linkFileName }"
  },
  "selection_b52c4c5e": {
    "message": "Udvælgelse"
  },
  "set_header_scope_8c548f40": {
    "message": "Indstil overskriftens omfang"
  },
  "set_minus_b46e9b88": {
    "message": "Mængde minus"
  },
  "set_table_header_cfab13a0": {
    "message": "Indstil tabellens overskrift"
  },
  "sharp_music_ab956814": {
    "message": "Hævet (musik)"
  },
  "shift_arrows_4d5785fe": {
    "message": "SHIFT+pile"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "Shift-O for at åbne det pæne html-redigeringsværktøj."
  },
  "shortcut_911d6255": {
    "message": "Genvej"
  },
  "show_image_options_1e2ecc6b": {
    "message": "Vis billedindstillinger"
  },
  "show_link_options_545338fd": {
    "message": "Vis linkindstillinger"
  },
  "show_rolling_transcript_c1481744": {
    "message": "Vis rullende transskription"
  },
  "show_rolling_transcript_d353aca4": {
    "message": "Vis rullende transkription"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "Brugere, der er i stand til at se, gennemser websider hurtigt og leder efter store overskrifter. Skærmlæsere er afhængige af overskrifter for kontekstuel forståelse. Overskrifter bør anvende den rigtige struktur."
  },
  "sighted_users_browse_web_pages_quickly_looking_for_ade806f5": {
    "message": "Brugere, der er i stand til at se, gennemser websider hurtigt og leder efter store overskrifter. Skærmlæsere er afhængige af overskrifter for kontekstuel forståelse. Overskrifter bør være kortfattede inden for den rigtige struktur."
  },
  "sigma_5c35e553": {
    "message": "Sigma"
  },
  "sigma_variant_8155625": {
    "message": "Sigma (variant)"
  },
  "single_color_image_4e5d4dbc": {
    "message": "Enkeltfarvet billede"
  },
  "single_color_image_color_95fa9a87": {
    "message": "Enkeltfarvet billedfarve"
  },
  "size_b30e1077": {
    "message": "Størrelse"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "Tekstfilens størrelse er større end den tilladte filstørrelse på maks. { max } kb."
  },
  "small_b070434a": {
    "message": "Lille"
  },
  "small_width_x_height_px_359acd38": {
    "message": "Lille ({ width } x { height } px)"
  },
  "solid_circle_9f061dfc": {
    "message": "Farvet cirkel"
  },
  "something_went_wrong_89195131": {
    "message": "Noget gik galt."
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "Noget gik galt ved adgang til dit webcam."
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "Der gik noget galt, og jeg ved ikke, hvad jeg skal vise dig."
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "Noget gik galt. Tjek din forbindelse, genindlæs siden, og prøv igen."
  },
  "something_went_wrong_d238c551": {
    "message": "Noget gik galt"
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "Noget gik galt under deling af din skærm."
  },
  "sort_by_e75f9e3e": {
    "message": "Sorter efter"
  },
  "spades_suit_b37020c2": {
    "message": "Spar (kulør)"
  },
  "square_511eb3b3": {
    "message": "Kvadrat"
  },
  "square_cap_9ec88646": {
    "message": "Firkantet fællesmængde"
  },
  "square_cup_b0665113": {
    "message": "Firkantet foreningsmængde"
  },
  "square_root_e8bcbc60": {
    "message": "Kvadratrod"
  },
  "square_root_symbol_d0898a53": {
    "message": "Kvadratrod-symbol"
  },
  "square_subset_17be67cb": {
    "message": "Kvadratisk delmængde"
  },
  "square_subset_strict_7044e84f": {
    "message": "Kvadratisk delmængde (streng)"
  },
  "square_superset_3be8dae1": {
    "message": "Kvadratisk overmængde"
  },
  "square_superset_strict_fa4262e4": {
    "message": "Kvadratisk overmængde (streng)"
  },
  "square_unordered_list_b15ce93b": {
    "message": "firkantet usorteret liste"
  },
  "star_8d156e09": {
    "message": "Stjerne"
  },
  "start_over_f7552aa9": {
    "message": "Start forfra"
  },
  "start_recording_9a65141a": {
    "message": "Start optagelse"
  },
  "steel_blue_14296f08": {
    "message": "Stålblå"
  },
  "studio_media_options_ee504361": {
    "message": "Studio-medieindstillinger"
  },
  "studio_media_options_tray_cfb94654": {
    "message": "Bakke til Studio-medieindstillinger"
  },
  "styles_2aa721ef": {
    "message": "Stile"
  },
  "submit_a3cc6859": {
    "message": "Aflever"
  },
  "submitting_b90fac62": {
    "message": "Afleverer ..."
  },
  "subscript_59744f96": {
    "message": "Sænket skrift"
  },
  "subset_19c1a92f": {
    "message": "Delmængde"
  },
  "subset_strict_8d8948d6": {
    "message": "Delmængde (streng)"
  },
  "succeeds_9cc31be9": {
    "message": "Kommer efter"
  },
  "succeeds_equal_158e8c3a": {
    "message": "Kommer efter lig med"
  },
  "sum_b0842d31": {
    "message": "Sum"
  },
  "superscript_8cb349a2": {
    "message": "Hævet skrift"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "Hævet skrift og sænket skrift"
  },
  "superset_c4db8a7a": {
    "message": "Overmængde"
  },
  "superset_strict_c77dd6d2": {
    "message": "Overmængde (streng)"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "Understøttede filtyper: SRT eller WebVTT"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "Skift til det pæne HTML-redigeringsværktøj"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "Skift til det rå HTML-redigeringsværktøj"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "Skift til det rå html-redigeringsværktøj"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "Skift til Rich Text Editor"
  },
  "syllabus_f191f65b": {
    "message": "Læseplan"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "Systemlyd tilladt"
  },
  "system_audio_disabled_c177bd13": {
    "message": "Systemlyd deaktiveret"
  },
  "tab_arrows_4cf5abfc": {
    "message": "TAB / pile"
  },
  "table_header_starting_with_start_ffcabba6": {
    "message": "Tabeloverskrift, der starter med { start }"
  },
  "table_starting_with_start_e7232848": {
    "message": "Tabel, der starter med { start }"
  },
  "tables_headers_should_specify_scope_5abf3a8e": {
    "message": "Tabeloverskrifter skal angive omfang."
  },
  "tables_should_include_a_caption_describing_the_con_e91e78fc": {
    "message": "Tabeller skal indeholde en billedtekst, der beskriver tabellens indhold."
  },
  "tables_should_include_at_least_one_header_48779eac": {
    "message": "Tabeller skal indeholde mindst et overskrift."
  },
  "tau_880974b7": {
    "message": "Tau"
  },
  "teal_f729a294": {
    "message": "Grønblå"
  },
  "text_7f4593da": {
    "message": "Tekst"
  },
  "text_background_color_16e61c3f": {
    "message": "Tekstens baggrundsfarve"
  },
  "text_color_acf75eb6": {
    "message": "Tekstfarve"
  },
  "text_is_difficult_to_read_without_sufficient_contr_69e62bd6": {
    "message": "Tekst er vanskelig at læse uden tilstrækkelig kontrast mellem tekst og baggrund, især for personer med dårligt syn."
  },
  "text_larger_than_18pt_or_bold_14pt_should_display__5c364db6": {
    "message": "Tekst større end 18pt (eller fed 14pt) skal have et kontrastforhold på mindst 3:1."
  },
  "text_optional_384f94f7": {
    "message": "Tekst (valgfrit)"
  },
  "text_position_8df8c162": {
    "message": "Tekstposition"
  },
  "text_size_887c2f6": {
    "message": "Tekststørrelse"
  },
  "text_smaller_than_18pt_or_bold_14pt_should_display_aaffb22b": {
    "message": "Tekst mindre end 18pt (eller fed 14pt) skal have et kontrastforhold på mindst 4,5:1."
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "Dokumentets forhåndsvisning bliver behandlet i øjeblikket. Prøv igen senere."
  },
  "the_first_heading_on_a_page_should_be_an_h2_859089f2": {
    "message": "Den første overskrift på en side skal være H2."
  },
  "the_height_of_rich_content_area_is_decreased_36920e0": {
    "message": "Højden på Rich Content-området er blevet reduceret."
  },
  "the_height_of_rich_content_area_is_increased_74c2358d": {
    "message": "Højden på Rich Content-området er blevet øget."
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "Materialer er på det offentlige domæne"
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "Materialet licenseres under Creative Commons"
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "Materialet er underlagt en undtagelse - fx fair brug, retten til at citere eller andre i henhold til gældende copyright-love"
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "Det pæne html-redigeringsværktøj er ikke tilgængeligt på tastaturet. Tryk på Shift-O for at åbne det rå html-redigeringsværktøj."
  },
  "therefore_d860e024": {
    "message": "Derfor"
  },
  "theta_ce2d2350": {
    "message": "Theta"
  },
  "theta_variant_fff6da6f": {
    "message": "Theta (variant)"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "Tyk nedadgående pil"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "Tyk venstre pil"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "Tyk venstre-pegende pil"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "Tyk højre pil"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "Tyk højre-pegende pil"
  },
  "thick_upward_arrow_acd20328": {
    "message": "Tyk opadgående pil"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "Dette dokument kan ikke vises i Canvas."
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "Dette regnestykke kan ikke gengives i Basisvisning."
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "Dette billede er for øjeblikket ikke tilgængeligt"
  },
  "this_video_may_display_youtube_ads_4d19d590": {
    "message": "Denne video kan vise YouTube-annoncer."
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "Selvom din video har den rigtige titel i browseren, kunne vi ikke opdatere den i databasen."
  },
  "thumbnail_e0de666f": {
    "message": "Thumbnail"
  },
  "timebar_a4d18443": {
    "message": "Tidslinje"
  },
  "title_can_t_be_blank_eb4021d7": {
    "message": "Titel må ikke være tom"
  },
  "title_ee03d132": {
    "message": "Titel"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "Skal slås op: { when }"
  },
  "to_do_when_2783d78f": {
    "message": "Opgaveliste: { when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "Skift { summary } gruppe"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "Skift værktøjstip"
  },
  "tools_2fcf772e": {
    "message": "Værktøjer"
  },
  "top_66e0adb6": {
    "message": "Top"
  },
  "transcript_panel_is_available_at_widths_above_720p_1cf94c0d": {
    "message": "Transskriptionspanelet er tilgængeligt i bredder over 720 px."
  },
  "tray_839df38a": {
    "message": "Bakke"
  },
  "triangle_6072304e": {
    "message": "Trekant"
  },
  "turnstile_yields_f9e76df1": {
    "message": "Drejekors (afkast)"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "tryk Ctrl + F9 for at få adgang til billedindstillinger. { text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "tryk Ctrl + F9 for at få adgang til linkindstillinger. { text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "tryk Ctrl + F9 for at få adgang til tabelindstillinger. { text }"
  },
  "unable_to_determine_resource_selection_url_7867e060": {
    "message": "Kan ikke bestemme webadressen til ressourcevalg"
  },
  "underline_applied_ae01ec97": {
    "message": "Understregning anvendt"
  },
  "underline_removed_3693e17c": {
    "message": "Understregning fjernet"
  },
  "union_e6b57a53": {
    "message": "Union"
  },
  "unpublished_dfd8801": {
    "message": "Ikke offentliggjort"
  },
  "unsaved_changes_will_be_lost_f977252a": {
    "message": "Ikke-gemte ændringer vil gå tabt."
  },
  "untitled_16aa4f2b": {
    "message": "Uden titel"
  },
  "untitled_efdc2d7d": {
    "message": "uden titel"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "Op og venstre diagonal pil"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "Op og højre diagonal pil"
  },
  "up_c553575d": {
    "message": "Op"
  },
  "updated_link_a827e441": {
    "message": "Opdateret link"
  },
  "upload_document_253f0478": {
    "message": "Upload dokument"
  },
  "upload_file_fd2361b8": {
    "message": "Overfør fil"
  },
  "upload_image_6120b609": {
    "message": "Upload billede"
  },
  "upload_media_ce31135a": {
    "message": "Upload medier"
  },
  "upload_record_media_e4207d72": {
    "message": "Upload / optag medier"
  },
  "uploading_19e8a4e7": {
    "message": "Uploader"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "store bogstaver alfabetisk sorteret liste"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "Delta med stort bogstav"
  },
  "uppercase_gamma_86f492e9": {
    "message": "Gamma med stort bogstav"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "Lambda med stort bogstav"
  },
  "uppercase_omega_8aedfa2": {
    "message": "Omega med stort bogstav"
  },
  "uppercase_phi_caa36724": {
    "message": "Phi med stort bogstav"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "Pi med stort bogstav"
  },
  "uppercase_psi_6395acbe": {
    "message": "Psi med stort bogstav"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "store bogstaver romertal sorteret liste"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "Sigma med stort bogstav"
  },
  "uppercase_theta_49afc891": {
    "message": "Theta med stort bogstav"
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "Upsilon med stort bogstav"
  },
  "uppercase_xi_341e8556": {
    "message": "Xi med stort bogstav"
  },
  "upsilon_33651634": {
    "message": "Upsilon"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "Opad- og nedadpegende pil"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "Opad- og nedadpegende pil (tyk)"
  },
  "upward_arrow_9992cb2d": {
    "message": "Opadpegende pil"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "Opadpegende trekant"
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "Brugsrettigheder:"
  },
  "usage_rights_required_5fe4dd68": {
    "message": "Brugsrettigheder (påkrævet)"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "Brug piletasterne til at navigere indstillinger."
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "Brug piletasterne til at vælge en form."
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "Brug piletasterne til at vælge en størrelse."
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "Brug piletasterne til at vælge en tekstposition."
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "Brug piletasterne til at vælge en tekststørrelse."
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "Brug piletasterne til at vælge en konturstørrelse."
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "Bruges af skærmlæsere til at beskrive indholdet af en { TYPE }"
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "Bruges af skærmlæsere til at beskrive et billedes indhold"
  },
  "user_documents_c206e61f": {
    "message": "Brugerdokumenter"
  },
  "user_files_78e21703": {
    "message": "Brugerfiler"
  },
  "user_images_b6490852": {
    "message": "Brugerbilleder"
  },
  "user_media_14fbf656": {
    "message": "Brugermedier"
  },
  "vector_notation_cf6086ab": {
    "message": "Vektor (notation)"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "Lodret bjælke (notering af mængder)"
  },
  "vertical_dots_bfb21f14": {
    "message": "Lodrette prikker"
  },
  "video_options_24ef6e5d": {
    "message": "Videoindstillinger"
  },
  "video_options_tray_3b9809a5": {
    "message": "Bakke for videoindstillinger"
  },
  "video_player_b371005": {
    "message": "Videoafspiller"
  },
  "video_player_for_9e7d373b": {
    "message": "Videoafspiller til "
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "Videoafspiller til { title }"
  },
  "video_url_889d3263": {
    "message": "Video-URL"
  },
  "view_all_e13bf0a6": {
    "message": "Se alle"
  },
  "view_ba339f93": {
    "message": "Vis"
  },
  "view_description_30446afc": {
    "message": "Vis beskrivelse"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "Se tastaturgenveje"
  },
  "view_title_description_67940918": {
    "message": "Vis { title } beskrivelse"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "Se antal ord og tegn"
  },
  "viewer_restrictions_e14274c9": {
    "message": "Seerbegrænsninger"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "Vi kunne ikke registrere en fungerende mikrofon tilsluttet til din enhed."
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "Vi kunne ikke registrere et fungerende webcam tilsluttet til din enhed."
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "Vi kunne ikke registrere et fungerende webkamera eller en mikrofon tilsluttet din enhed."
  },
  "webcam_disabled_30c66986": {
    "message": "Webcam deaktiveret"
  },
  "webcam_fe91b20f": {
    "message": "Webcam"
  },
  "webpages_should_only_have_a_single_h1_which_is_aut_dc99189e": {
    "message": "Websider bør kun have en enkelt H1, som automatisk bruges af sidens titel. Den første overskrift i dit indhold skal være H2."
  },
  "when_markup_is_used_that_visually_formats_items_as_f941fc1b": {
    "message": "Når der anvendes fremhævelse, der visuelt formaterer elementer i listeform, men som ikke angiver listeforholdet, kan brugere have svært ved at navigere gennem oplysningerne."
  },
  "white_87fa64fd": {
    "message": "Hvid"
  },
  "why_523b3d8c": {
    "message": "Hvorfor"
  },
  "width_492fec76": {
    "message": "Bredde"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "Bredde og højde skal være tal"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width } x { height } px"
  },
  "wiki_home_9cd54d0": {
    "message": "Wiki startside"
  },
  "word_count_c77fe3a6": {
    "message": "Ordtælling"
  },
  "words_b448b7d5": {
    "message": "Ord"
  },
  "wreath_product_200b38ef": {
    "message": "Krans-produkt"
  },
  "xi_149681d0": {
    "message": "Xi"
  },
  "yes_dde87d5": {
    "message": "Ja"
  },
  "you_are_on_a_color_palette_to_navigate_on_the_pale_227fc3a6": {
    "message": "Du er på en farvepalet. For at navigere på paletten op, til venstre, ned eller til højre skal du bruge henholdsvis ''W'', ''A'', ''S'' og ''D'' knapperne"
  },
  "you_are_on_a_color_slider_to_navigate_the_slider_l_e800f68a": {
    "message": "Du er på en farveskyder. For at navigere skyderen til venstre eller højre skal du bruge henholdsvis ''A'' og ''D'' knapperne"
  },
  "you_are_on_an_alpha_slider_to_navigate_the_slider__3a014dc5": {
    "message": "Du er på en alfa-skyder. For at navigere skyderen til venstre eller højre skal du bruge henholdsvis ''A'' og ''D'' knapperne"
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "Du har ikke-gemte ændringer i Icon Maker-bakken. Vil du fortsætte uden at gemme disse ændringer?"
  },
  "you_may_need_to_adjust_additional_headings_to_main_975f0eee": {
    "message": "Du skal muligvis justere yderligere overskrifter for at bevare sidehierarkiet."
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "Du må ikke uploade en tom fil."
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "Dit billede er blevet komprimeret til Icon Maker. Billeder mindre end { size } KB vil ikke blive komprimeret."
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "Din mikrofon er blokeret i browserindstillingerne."
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "Dit webcam og din mikrofon er blokeret i browserindstillingerne."
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "Dit webcam er blokeret i browserindstillingerne."
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "Dit webcam kan allerede være i brug."
  },
  "youtube_embed_url_5c1018d4": {
    "message": "YouTube-indlejrings-URL"
  },
  "zeta_5ef24f0e": {
    "message": "Zeta"
  },
  "zoom_f3e54d69": {
    "message": "Zoom"
  },
  "zoom_in_image_bb97d4f": {
    "message": "Zoom ind på billede"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "Zoom ud på billede"
  }
};
formatMessage.addLocale({
  da: locale
});